import DefaultDataProvider from './DefaultDataProvider';
export default DefaultDataProvider;
